module.exports = __webpack_public_path__ + "img/guide_device_connect.fb13e22e.png";